import React from 'react';

export interface StepperProgressProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  color?: string;
}

function StepperProgress({ className = '', color, ...props }: StepperProgressProps): JSX.Element {
  const progressStyle = {
    backgroundColor: color || '#cbcbcb', // cor padrão se nenhuma cor for especificada
  };

  return (
    <div className={`stepper-progress ${className}`} style={progressStyle} {...props}>
      <div className="stepper-progress-bar" role="progressbar" />
    </div>
  );
}

export default StepperProgress;
